import React, { createContext, useContext, useEffect, useState } from "react";
import api, { getToken, setTokens, clearTokens } from "../api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [viewAsApplicant, setViewAsApplicantState] = useState(() => localStorage.getItem("cc_view_as_applicant") === "1");

  const setViewAsApplicant = (v) => {
    if (v) localStorage.setItem("cc_view_as_applicant", "1");
    else localStorage.removeItem("cc_view_as_applicant");
    setViewAsApplicantState(!!v);
  };

  useEffect(() => {
    const token = getToken();
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => clearTokens())
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password, remember = true) => {
    const res = await api.post("/auth/login", { email, password });
    setTokens(res.data.token, res.data.refresh_token, remember);
    setUser(res.data.user);
    return res.data.user;
  };

  const signup = async (payload) => {
    const res = await api.post("/auth/signup", payload);
    setTokens(res.data.token, res.data.refresh_token, true);
    setUser(res.data.user);
    return res.data.user;
  };

  const logout = () => {
    clearTokens();
    setUser(null);
  };

  const refreshUser = async () => {
    const res = await api.get("/auth/me");
    setUser(res.data);
    return res.data;
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, login, signup, logout, refreshUser, viewAsApplicant, setViewAsApplicant }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
